/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Row_ConnectedInputs */



/**
* | output |
* | --- |
* | "Connected" |
*
* @param {Integrations_Row_ConnectedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_row_connected = /** @type {((inputs?: Integrations_Row_ConnectedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Row_ConnectedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbunden")
	return /** @type {LocalizedString} */ ("Connected")
});